import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.search";
// The app loader's settings (#223). Its look before the login is known: the look of the last one who logged in on this
// browser (owners and admins Atlas, fans Duin). On dev only, the address can hold it on screen to look at it:
// ?loaderHold=1 plays a logged-in first load over and over, ?loaderPause=1 makes the first load take 10 s, and
// ?loaderLook=atlas|duin picks the look.
import Vue from 'vue';
export var LOOKS = ['atlas', 'duin'];
var KEY = 'gm-app-loader';

var read = function read() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || {};
  } catch (e) {
    return {};
  }
};

var query = process.env.DEV ? new URLSearchParams(window.location.search) : new URLSearchParams();

var pick = function pick(value) {
  return LOOKS.indexOf(value) !== -1 ? value : null;
};

var write = function write(patch) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(Object.assign(read(), patch)));
  } catch (e) {}
};

export var loaderPrefs = Vue.observable({
  look: pick(query.get('loaderLook')),
  hold: query.get('loaderHold') === '1',
  pause: query.get('loaderPause') === '1',
  lastLook: pick(read().lastLook) || 'duin'
});
export var saveLastLook = function saveLastLook(look) {
  loaderPrefs.lastLook = look;
  write({
    lastLook: look
  });
};